module.exports = __webpack_public_path__ + "img/undertakingCases19.3905ebc6.jpg";